import { apiRequest } from "./api";

// PUT /settings/change-password re-verifies currentPassword server-side and
// does not invalidate the caller's existing session token (unlike
// resetPassword, which is for the "I might have lost control of my account"
// flow) - see the backend's AuthServiceImpl.changePassword.
export async function changePassword({ currentPassword, newPassword, confirmPassword }) {
  return apiRequest("/settings/change-password", {
    method: "PUT",
    body: { currentPassword, newPassword, confirmPassword },
  });
}
